import { Filters } from "./types";
import { InsuranceServiceDto } from "@apiModels/Insurance/InsuranceServiceDto.csharp";

export function filterServices(
  filters: Filters,
  services: InsuranceServiceDto[]
) {
  const { specialization, locations } = filters;

  if (!specialization) return [];

  const servicesBySpecialization = services.filter(
    (service) => service.specializationId === specialization.id
  );

  if (locations && locations.length > 0) {
    const servicesBySpecializationLocation = servicesBySpecialization.filter(
      (service) => {
        const serviceLocations = service.centerBookingOptions.map(
          (serviceLocation) => serviceLocation.centerId
        );
        const locationsIds = locations.flatMap((location) =>
          location.isLocation ? location.centers : location.id
        );

        return serviceLocations.some((item) => locationsIds.includes(item));
      }
    );

    return servicesBySpecializationLocation;
  }

  return servicesBySpecialization;
}
